import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOutlinedQuestionMark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 7.5C0 3.36 3.36 0 7.5 0C11.64 0 15 3.36 15 7.5C15 11.64 11.64 15 7.5 15C3.36 15 0 11.64 0 7.5ZM8.25 10.5V12H6.75V10.5H8.25ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM4.5 6C4.5 4.3425 5.8425 3 7.5 3C9.1575 3 10.5 4.3425 10.5 6C10.5 6.96219 9.90748 7.47999 9.33057 7.98415C8.78326 8.46245 8.25 8.92847 8.25 9.75H6.75C6.75 8.38404 7.45659 7.84244 8.07783 7.36626C8.56518 6.99271 9 6.65941 9 6C9 5.175 8.325 4.5 7.5 4.5C6.675 4.5 6 5.175 6 6H4.5Z",
		fill: "#0071CD"
	})
});
export default SvgOutlinedQuestionMark;
